/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Warning_Scale_MismatchInputs */

const en_us2_body_assessment_warning_scale_mismatch = /** @type {(inputs: Body_Assessment_Warning_Scale_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The front and side photos were taken from different distances. Keep the phone and your feet in the same place for both.`)
};

const pt_br2_body_assessment_warning_scale_mismatch = /** @type {(inputs: Body_Assessment_Warning_Scale_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As fotos de frente e de lado foram tiradas a distâncias diferentes. Mantenha o celular e os seus pés no mesmo lugar nas duas.`)
};

const es_419_body_assessment_warning_scale_mismatch = /** @type {(inputs: Body_Assessment_Warning_Scale_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las fotos de frente y de lado se tomaron a distancias diferentes. Mantén el teléfono y tus pies en el mismo lugar para las dos.`)
};

const pt_pt2_body_assessment_warning_scale_mismatch = /** @type {(inputs: Body_Assessment_Warning_Scale_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As fotos de frente e de lado foram tiradas a distâncias diferentes. Mantém o telemóvel e os teus pés no mesmo sítio nas duas.`)
};

const fr_fr2_body_assessment_warning_scale_mismatch = /** @type {(inputs: Body_Assessment_Warning_Scale_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les photos de face et de profil ont été prises à des distances différentes. Garde le téléphone et tes pieds au même endroit pour les deux.`)
};

const de_de2_body_assessment_warning_scale_mismatch = /** @type {(inputs: Body_Assessment_Warning_Scale_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Front- und Seitenfoto wurden aus unterschiedlichem Abstand gemacht. Lass Handy und Füße bei beiden an derselben Stelle.`)
};

const it_it2_body_assessment_warning_scale_mismatch = /** @type {(inputs: Body_Assessment_Warning_Scale_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le foto frontale e laterale sono state scattate da distanze diverse. Tieni il telefono e i piedi nello stesso punto per entrambe.`)
};

/**
* | output |
* | --- |
* | "The front and side photos were taken from different distances. Keep the phone and your feet in the same place for both." |
*
* @param {Body_Assessment_Warning_Scale_MismatchInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_warning_scale_mismatch = /** @type {((inputs?: Body_Assessment_Warning_Scale_MismatchInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Warning_Scale_MismatchInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_warning_scale_mismatch(inputs)
	if (locale === "es-419") return es_419_body_assessment_warning_scale_mismatch(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_warning_scale_mismatch(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_warning_scale_mismatch(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_warning_scale_mismatch(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_warning_scale_mismatch(inputs)
	return en_us2_body_assessment_warning_scale_mismatch(inputs)
});
export { body_assessment_warning_scale_mismatch as "body-assessment.warning.scale_mismatch" }